import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import * as KeycloakAngular from "keycloak-angular";
import {Router} from "@angular/router";
import {KeycloakSupportService} from "@app/core";
import {DefaultOrg, RouteLink} from "@app/shared";
import {Realm} from "@app/keycloak/realm";
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-realm-selector',
  templateUrl: './realm-selector.component.html',
  styleUrls: ['./realm-selector.component.css']
})
export class RealmSelectorComponent implements OnInit {

  @Output() handleRealmSelection: EventEmitter<Realm> = new EventEmitter<Realm>();

  RouteLink: typeof RouteLink = RouteLink;

  realm: string;
  isLoggedIn: boolean;
  csrHostname: string;
  hostnameInURL: string;
  errorToolTipMsg: string;

  constructor(
    private keycloakAngular: KeycloakAngular.KeycloakService,
    private keycloakSupport: KeycloakSupportService,
    private router: Router) {
  }

  ngOnInit() {
    let url = new URL(window.location.href);
    this.realm = url.searchParams.get("realm");
    this.hostnameInURL = window.location.hostname.split(".")[0];
    this.csrHostname = environment.rootUrlForCSR.split("//")[1].split("/")[0].split(".")[0];

    console.log(`csrHostname = ${this.csrHostname}  hostnameInURL = ${this.hostnameInURL}`);

    const keycloakInstance = this.keycloakAngular.getKeycloakInstance();
    if (keycloakInstance && keycloakInstance.realm) {
      console.log("keycloakInstance and realm exist");
      this.realm = keycloakInstance.realm;
      //this.isLoggedIn = await this.keycloakAngularService.isLoggedIn();
    } else {
      // if companyId is one of the excluded ids, then set the companyId to null. this should include localhost, dev, qa, onelynk, ... etc...
      if (environment.excludedDefaultOrgIdInURL && environment.excludedDefaultOrgIdInURL.find(obj => obj.orgId == this.hostnameInURL)) {
        this.realm = null;
      } else {
        if (this.csrHostname != this.hostnameInURL) {
          console.log("setting realm with hostnameInURL...");
          this.realm = this.hostnameInURL;
        }
      }
    }
  }

  onClickProceedToLogin() {
    if (environment.checkUrlForCSR && this.realm == DefaultOrg.Realm && this.hostnameInURL != this.csrHostname) {
      this.errorToolTipMsg = "This website does not allow access for CSR";
    } else if (environment.checkUrlForCSR && this.realm != DefaultOrg.Realm && this.hostnameInURL == this.csrHostname) {
      this.errorToolTipMsg = "This website is for only CSR. No other company can login using this website.";
    } else {
      this.keycloakSupport.isValidRealm(this.realm).subscribe(valid => {
        console.log("valid = ", valid);
        if (valid) {
          this.errorToolTipMsg = null;
          const realm = {
            displayName: null,
            clientId: environment.keycloakConfig.clientId,
            name: this.realm
          };
          this.handleRealmSelection.emit(realm);
        } else {
          this.errorToolTipMsg = "Company ID is not valid!";
        }
      });
    }
  }

  onClickProceedToHomePage() {
    void this.router.navigate([RouteLink.Home]);
  }
}
